<template>
  <div>
    <HeroSection
      :nav-breadcrumbs="[
        {
          href: '/contact',
          title: 'Contact Us'
        }
      ]"
      :value="contactPage.hero_section"
    >
    </HeroSection>

    <ContactFormSection
      :value="contactPage.contact_form_section"
      class="mb-16 hero-section hero-below-offset"
    />
  </div>
</template>

<script setup>
defineProps({
  contactPage: {
    required: true,
    type: Object
  }
})
</script>
